import React from "react";
import { colors } from "../../../../../../themes/Colors";

const UserHeader = () => {
  return (
    <div
      style={{
        minHeight: 40,
        width: "100%",
        backgroundColor: colors.secondaryDarkBlue,
        color: colors.white,
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          flex: 0.2,
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 13, fontWeight: "bold", marginLeft: 20 }}>
          USER HEDAER
        </div>
      </div>
      <div
        style={{
          flex: 0.15,

          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 13, fontWeight: "bold", width: "90%" }}>
          CELL NUMBER
        </div>
      </div>
      <div
        style={{
          flex: 0.2,

          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 13, fontWeight: "bold", width: "90%" }}>
          EMAIL
        </div>
      </div>
      <div
        style={{
          flex: 0.35,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 13, fontWeight: "bold", width: "90%" }}>
          LAST TASK
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 13, fontWeight: "bold" }}>ACTIONS</div>
      </div>
    </div>
  );
};

export default UserHeader;
